// extracted by mini-css-extract-plugin
export default {"greetingsWrap":"Greetings_greetingsWrap__JeOLc","contentWrap":"Greetings_contentWrap__RmkFD","imgWrap":"Greetings_imgWrap__iKVdS","textWrap":"Greetings_textWrap__Ybs3u"};